import { render, staticRenderFns } from "./ConceptoSPPage.vue?vue&type=template&id=53e75a64"
import script from "./ConceptoSPPage.js?vue&type=script&lang=js&external"
export * from "./ConceptoSPPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports